import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { SERVER_PATH } from "../../../config/env";
import { FadeLoader } from "react-spinners";
import apiClient from "../../../utils/api";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#000",
};

export default function GardenSingleProduct() {
  const [gardenProduct, setGardenProduct] = useState([]);

  const fetchData = () => {
    apiClient
      .post(`get/all_products.php`, {
        category: "vegetables",
      })
      .then((res) => {
        setGardenProduct(res.data.data);
      });
  };

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {gardenProduct.length >= 1 ? (
        <>
          {gardenProduct.map((datas, index) => {
            return (
              <div className="col-md-3" key={"product" + index}>
                {datas.productId === [] ? (
                  <div
                    className="card mb-4 product-wap rounded-1"
                    style={{ height: "350px" }}
                  >
                    <h2>Loading</h2>
                  </div>
                ) : (
                  <div
                    className="card mb-4 product-wap rounded-1"
                    style={{ height: "350px" }}
                  >
                    <div className="card rounded-0">
                      <img
                        className="card-img rounded-0 img-fluid"
                        style={{ height: "180px", objectFit: "contain" }}
                        src={datas.img1}
                        alt={datas.product_name}
                      />
                      <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                        <ul className="list-unstyled">
                          <li>
                            <Link
                              className="btn btn-success text-white mt-2"
                              to={`/product/${datas.product_id}`}
                            >
                              <AiOutlineEye
                                style={{ fontSize: "1.3em", marginTop: "-3px" }}
                              />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <Link to="/" className="h3 text-decoration-none">
                        {datas.product_name}
                        <small className="productWeight ms-1">
                          {datas.weight}Gms.
                        </small>
                      </Link>
                      <span className="d-block text-secondary my-2">
                        RS.{datas.offer_price}
                      </span>
                      <Link to={`/product/${datas.product_id}`}>
                        <button className="btn btn-sm w-100 btn-outline-success text-uppercase">
                          Buy Now
                        </button>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </>
      ) : (
        <>
          <FadeLoader color="#000" size={250} cssOverride={override} />
          <h2 className="text-center mt-3">Loading...</h2>
        </>
      )}
    </>
  );
}
